module.exports = __webpack_public_path__ + "img/3.fe508954.jpg";